import { useFpCampaignCouponService } from '@cart-services/hooks/useFpCampaignCouponService'
import { CouponCondition } from '@cart-ui/CouponCondition/CouponCondition'
import { RegularGiveawayProgressBar } from '@cart-ui/RegularGiveawayProgressBar/RegularGiveawayProgressBar'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { HStack } from '@pets-ui/HStack/HStack'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { formatPrice } from '@utils'
import { useMemo } from 'react'
import { useProductCatalog } from '../ProductCatalogProvider/useProductCatalog'

interface DialogRegularGiveawayTipsProps {
  open: boolean
  onClose: () => void
}

export function DialogRegularGiveawayTips(props: DialogRegularGiveawayTipsProps) {
  const { open, onClose } = props
  const { currency, campaignId, countryCode, campaignCode } = useProductCatalog()
  const { regularGiveaways, getRegularGiveawayProgress } = useFpCampaignCouponService(
    campaignId,
    countryCode,
    campaignCode,
  )
  const { totalAmount, percentage, totalCriterions, currentCriterions, subtractionTotal } = useMemo(() => getRegularGiveawayProgress(regularGiveaways ?? []), [regularGiveaways, getRegularGiveawayProgress])
  return (
    <ResponsiveDialog
      open={open}
      onClose={onClose}
      fullWidth
    >
      <DialogHeader title="滿額禮" onClose={onClose} />
      <DialogContent p={4}>
        <VStack gap={2} p={4} backgroundColor={colors.white}>
          <HStack width="100%" gap={2}>
            <HStack justifyContent="space-between" flex={1}>
              <RegularGiveawayProgressBar
                total={totalCriterions}
                current={currentCriterions}
                value={percentage}
                displayText={false}
              />
            </HStack>
            {percentage < 100 ? <Text variant="caption" color={colors.grey800}>{`再消費 ${formatPrice(currency, subtractionTotal)}`}</Text> : <Text variant="caption" color={colors.green400}>已符合</Text>}
          </HStack>

          {regularGiveaways?.flatMap(regularGiveaway => regularGiveaway.criterions.map(criterion => (
            <CouponCondition
              key={criterion.display_name}
              displayName={criterion.display_name}
              isApplied={totalAmount >= (criterion.criterion_amount ?? 0)}
              moreAmount={(criterion.criterion_amount ?? 0) - totalAmount}
              moreQuantity={criterion.left_quantity ?? criterion.display_criterion_quantity}
              count={criterion.count}
            />
          )))}
        </VStack>
      </DialogContent>
    </ResponsiveDialog>
  )
}
